import LoadingButton from '@mui/lab/LoadingButton';
import { Box } from '@mui/material';
import { FormEventHandler, useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { GoogleMapAddress } from '../../../../../types/util';
import { GoogleMapLocationField } from '../../../../google-map-location-field/GoogleMapLocationField';
import { TextInput } from '../../../../text-input/TextInput';
import { FillPersonalQualificationHeader } from '../../../shared/QualificationFormHeader';
import { GuestUserQualificationCreateInputs } from '../../types';

interface GuestUserPersonalInputProps {
  isLoading: boolean;
  form: UseFormReturn<GuestUserQualificationCreateInputs>;
  onSubmit: FormEventHandler;
}

export const GuestUserPersonalInput: React.FC<GuestUserPersonalInputProps> = ({
  form: {
    formState: { errors },
    getValues,
    setValue,
    register,
  },
  onSubmit,
  isLoading,
}) => {
  const updateAddress = useCallback(
    (address: GoogleMapAddress): void => {
      const location = getValues('address');
      if (address.location !== location) {
        setValue('address', address.location, { shouldValidate: location?.trim().length === 0 });
      }
      setValue('address_lat', address.lat);
      setValue('address_lng', address.lng);
    },
    [setValue, getValues]
  );
  return (
    <Box>
      <FillPersonalQualificationHeader />
      <form onSubmit={onSubmit}>
        <TextInput
          required
          label="Full Name"
          placeholder="Your Full Name"
          FieldProps={register('full_name')}
          error={errors.full_name?.message}
        />
        <TextInput
          FieldProps={{ ...register('email'), type: 'email' }}
          required
          error={errors.email?.message}
          id="eligibility-qualification-find-email-field"
          placeholder="Your Email Address"
          label="Email"
        />
        <TextInput
          required
          label="Phone Number"
          placeholder="Your Phone Number"
          FieldProps={register('phone')}
          error={errors.phone?.message}
        />
        <GoogleMapLocationField
          required
          FieldProps={register('address')}
          placeholder="Your Current Address"
          label="Your Current Address"
          id="upsert-qualification-address-field"
          LatitudeInputProps={register('address_lat')}
          LongitudeInputProps={register('address_lng')}
          onChange={updateAddress}
          error={errors.address?.message || errors.address_lat?.message || errors.address_lng?.message}
        />
        <LoadingButton loading={isLoading} variant="contained" sx={{ width: 1 }} type="submit">
          Create my qualification
        </LoadingButton>
      </form>
    </Box>
  );
};
